import React from "react";

export default function ProductDescription({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="single-pro-desc">
      <h5 className="ec-single-title">{title}</h5>
      {/* <div className="ec-single-rating-wrap">
        <div className="ec-single-rating">
          {Array.from({ length: 5 }).map((_, idx) => (
            <i
              key={idx}
              className={`ecicon eci-star ${idx < 4 ? "fill" : "eci-star-o"}`}
            />
          ))}
        </div>
        <span className="ec-read-review">
          <a href="#ec-spt-nav-review">Be the first to review this product</a>
        </span>
      </div> */}
      <div className="ec-single-desc">{description}</div>
      {/* <div className="ec-single-price-stoke">
        <div className="ec-single-price">
          <span className="ec-single-ps-title">As low as</span>
          <span className="new-price">$97.00</span>
        </div>
        <div className="ec-single-stoke">
          <span className="ec-single-ps-title">IN STOCK</span>
          <span className="ec-single-sku">SKU#: WH12</span>
        </div>
      </div> */}
    </div>
  );
}
